// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Red Hat Display', 'Red Hat Display Fallback'","fontStyle":"normal"},"className":"__className_38fe0e","variable":"__variable_38fe0e"};